<script setup lang="ts">
/**
 * ScholarTrip 專業級頁尾 (The Footer)
 * 1. 針對 AEO/GEO 規劃的 SEO 連結矩陣
 * 2. 整合 IATA、NDC、PCI 合規標章，建立信任感
 * 3. 解決 RWD 下資訊過度擁擠的問題
 */
const footerGroups = [
  {
    title: "Global Travel",
    links: [
      "Student Flights",
      "Hotel Bundles",
      "Airport Transfers",
      "Group Requests",
      "Travel Insurance",
    ],
  },
  {
    title: "Company",
    links: [
      "About ScholarTrip",
      "TMC Partners",
      "Careers",
      "Global Newsroom",
      "Sustainability",
    ],
  },
  {
    title: "Legal & Support",
    links: [
      "Help Center",
      "Baggage Rules",
      "Cancellation Policy",
      "Privacy",
      "Terms of Service",
    ],
  },
];
</script>
<template>
  <footer
    class="bg-slate-950 text-slate-400 pt-24 pb-12 font-sans overflow-hidden"
  >
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-12 gap-16 mb-24">
        <!-- 品牌簡介區 -->
        <div class="md:col-span-4">
          <BaseAppLogo :is-light="true" class="mb-8 opacity-90" />
          <p class="text-sm leading-relaxed max-w-sm mb-10 text-slate-500">
            ScholarTrip is the leading travel platform built for global
            explorers. Official partner of 80+ airlines providing verified
            student and general traveler fares.
          </p>
          <div class="flex gap-4">
            <button
              v-for="icon in ['instagram', 'twitter', 'facebook', 'linkedin']"
              :key="icon"
              class="w-10 h-10 bg-white/5 rounded-xl flex items-center justify-center hover:bg-brand-600 hover:text-white transition-all"
            >
              <Icon :name="`ph:${icon}-logo-bold`" />
            </button>
          </div>
        </div>
        <!-- 連結連結矩陣 -->
        <div class="md:col-span-8 grid grid-cols-2 lg:grid-cols-3 gap-10">
          <div v-for="group in footerGroups" :key="group.title">
            <h5
              class="text-white font-black text-[10px] uppercase tracking-[0.3em] mb-8"
            >
              {{ group.title }}
            </h5>
            <ul class="space-y-4 text-sm font-bold">
              <li v-for="link in group.links" :key="link">
                <NuxtLink
                  to="#"
                  class="hover:text-action-400 transition-colors duration-300"
                  >{{ link }}</NuxtLink
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 合規標章區 -->
      <div
        class="pt-16 border-t border-white/10 flex flex-col lg:flex-row justify-between items-center gap-10"
      >
        <div class="flex flex-col items-center lg:items-start gap-2">
          <p
            class="text-[9px] font-black uppercase tracking-[0.2em] opacity-30"
          >
            © {{ new Date().getFullYear() }} ScholarTrip Global Travel
            Management.
          </p>
          <p
            class="text-[9px] font-black uppercase tracking-[0.2em] opacity-30 italic"
          >
            IATA Accredited Agency #1234567 • NDC Certified GDS Integration.
          </p>
        </div>
        <div
          class="flex flex-wrap justify-center items-center gap-8 opacity-20 grayscale hover:opacity-50 transition-opacity duration-700"
        >
          <span
            class="text-[10px] font-black tracking-widest italic border border-white px-2 py-1"
            >SECURE PAYMENT</span
          >
          <span
            class="text-[10px] font-black tracking-widest italic border border-white px-2 py-1"
            >PCI-DSS COMPLIANT</span
          >
          <span
            class="text-[10px] font-black tracking-widest italic border border-white px-2 py-1"
            >SSL ENCRYPTED</span
          >
        </div>
      </div>
    </div>
  </footer>
</template>
